export * from './graphql.module';
export * from './services/ecap-graphlq.service';
